import { PublicEvent } from 'utils/publicEvents/events';

const eventsHistory: PublicEvent[] = [];

const getByName = (eventName: string): PublicEvent[] => {
  return eventsHistory.filter((event) => event.name === eventName);
};

const add = (event: PublicEvent): void => {
  eventsHistory.push(event);
};

const exportObject = {
  getByName,
  add,
};

export default exportObject;
